// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2I2CL","isVisible":"style_isVisible__2ZEcK","arrow":"style_arrow__8FxvX","fader":"style_fader__1-EMA"};